import React, { useContext, useEffect } from 'react';
import { flowSteps, recordFlowProgress } from '../../utils/recordFlowProgress';

import { Button } from 'react-bootstrap';
import { ConsentContext } from '../../context/ConsentContext';
import ReactMarkdown from 'react-markdown';
import { SpacerHr } from '../../ui/Styled';
import { contentfulPropTypes } from '../../propTypes';
import errorDisc from '../../assets/svg/disc/error-disc.svg';
import styled from 'styled-components';
import { useNavigate } from 'react-router';
import withContentfulTag from '../../utils/withContentfulTag';

const StyledH1 = styled.h1`
  margin-bottom: 25px;
`;

const StyledButton = styled(Button)`
  margin: 6px 0;
`;

const CannotConfirmContainer = ({ contentful, loading, fetched }) => {
  const navigate = useNavigate();
  const { consentFlow } = useContext(ConsentContext);

  useEffect(() => {
    const asyncRecordFlowProgress = async () => {
      await recordFlowProgress(flowSteps.CANNOT_CONFIRM_CC);
    };
    asyncRecordFlowProgress();
  }, []);

  const onTryDifferentCard = () => {
    navigate(`/${consentFlow}/card-details`);
  };
  const onContinue = () => {
    navigate(`/${consentFlow}/meter-code`);
  };

  return (
    !loading &&
    fetched && (
      <>
        <div className="text-center mb-3">
          <img src={errorDisc} alt="Error Disc" />
        </div>
        <StyledH1>{contentful.title}</StyledH1>
        <ReactMarkdown>{contentful.body}</ReactMarkdown>
        <StyledButton
          variant="primary"
          type="button"
          onClick={onTryDifferentCard}
          className="mb-3 w-100">
          {contentful.primaryButtonText}
        </StyledButton>
        <SpacerHr label="or" />
        <StyledButton
          variant="outline-primary"
          className="w-100"
          type="button"
          onClick={onContinue}>
          {contentful.secondaryButtonText}
        </StyledButton>
      </>
    )
  );
};

CannotConfirmContainer.propTypes = {
  ...contentfulPropTypes,
};

export default withContentfulTag(
  CannotConfirmContainer,
  'web_app_onboarding_cannot_confirm_page',
);
